import React from "react";
import Frame434 from "../Frame434";
import "./FAQ4False.css";

function FAQ4False(props) {
  const { className, frame434Props } = props;

  return (
    <div className={`faq4 ${className || ""}`}>
      <Frame434 line36={frame434Props.line36} className={frame434Props.className} />
    </div>
  );
}

export default FAQ4False;
